import { useTranslations } from 'next-intl'

import classnames from 'classnames'

import Image from '~/components/atoms/Image/Image'
import Link from '~/components/atoms/Link/Link'
import SpecificImage from '~/components/atoms/SpecificImage/SpecificImage'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import firstLettersConcatenated from '~/utils/firstLetterConcatenated'

import styles from './ArticleHeaderAuthor.module.css'

export interface ArticleHeaderAuthorProps {
  author: {
    name: string
    slug: string
    image: any
  }
  reviewedBy: {
    name: string
    slug: string
    image: any
  }
  clickEvent?: any
  centered?: boolean
  showDefault?: boolean
  authorPretext?: string
}

export default function ArticleHeaderAuthor({
  author,
  reviewedBy,
  clickEvent,
  centered = true,
  showDefault = true,
  authorPretext,
}: ArticleHeaderAuthorProps) {
  const t = useTranslations('common')
  const authorsName = author?.name ? author.name : 'Erin Argun'
  const reviewedByname = reviewedBy?.name
    ? reviewedBy.name
    : 'Charlotte Stewart'
  const defaultPretext = authorPretext || t('writtenBy')
  const useauthorPretext = !author?.name ? t('reviewedBy') : defaultPretext

  if (!showDefault && !author?.name) return null

  const authorSlug = author.slug ? author.slug : 'team/erin-atlanta-argun'

  return (
    <div className={styles.base}>
      <div
        className={classnames(
          styles.avatars,
          !reviewedBy?.name && styles.single
        )}
      >
        <div className={styles.firstAvatar}>
          <div className={classnames(styles.avatar)}>
            {!author && (
              <Image asset="https:cdn.sanity.io/images/dqllnil6/production/60496f739545b9cdc6d070b592b1162f675c5c59-1575x1912.png?w=120&q=60&auto=format" />
            )}
            {author?.image?.asset ? (
              <SpecificImage
                asset={author.image.asset}
                alt={author.name}
                width={120}
              />
            ) : (
              <div className={styles.intialsFallback}>
                <Text size={TextSizes.secondaryTitleMicro}>
                  {firstLettersConcatenated(authorsName)}
                </Text>
              </div>
            )}
          </div>
        </div>
        {reviewedBy?.name && (
          <div className={classnames(styles.secondAvatar)}>
            <div className={classnames(styles.avatar)}>
              {!reviewedBy && (
                <Image asset="https:cdn.sanity.io/images/dqllnil6/production/60496f739545b9cdc6d070b592b1162f675c5c59-1575x1912.png?w=64&q=60&auto=format" />
              )}
              {reviewedBy?.image?.asset ? (
                <SpecificImage
                  asset={reviewedBy.image.asset}
                  alt={reviewedBy.name}
                  width={60}
                />
              ) : (
                <div className={styles.intialsFallback}>
                  <Text size={TextSizes.secondaryTitleMicro}>
                    {firstLettersConcatenated(reviewedByname)}
                  </Text>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Text size={TextSizes.magPrimaryTitleSml} className={styles.expert}>
        <span>
          <em>{useauthorPretext}</em>{' '}
          <Link
            href={author?.name ? author.slug : authorSlug}
            className={styles.authorLink}
          >
            {authorsName}
          </Link>
        </span>
        <span className={styles.divider}>•</span>
      </Text>
      {reviewedBy?.name && (
        <Text size={TextSizes.magPrimaryTitleSml} className={styles.expert}>
          <em>{t('reviewedBy')}</em>{' '}
          <Link href={reviewedBy.slug} className={styles.authorLink}>
            {reviewedByname}
          </Link>
        </Text>
      )}
    </div>
  )
}
